import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";

type TableSlice = {
    dataCount?: number,
    caption?: string,
}

const initialState: TableSlice = {
    dataCount: undefined,
    caption: undefined
}

export const tableSlice = createSlice({
    name: 'table',
    initialState,
    reducers: {
        setTableDataCount(state, action: PayloadAction<number | undefined>) {
            state.dataCount = action.payload
        },
        setTableCaption(state, action: PayloadAction<string | undefined>) {
            state.caption = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return initialState
        })
    },
})

export const { setTableDataCount, setTableCaption } = tableSlice.actions
export const tableReducer = tableSlice.reducer;
